import { NamirasoftAccountCookieHeader } from "./NamirasoftAccountCookieHeader";
import { NamirasoftAccountReqHeader } from "./NamirasoftAccountReqHeader";
import { NamirasoftAccountResHeader } from "./NamirasoftAccountResHeader";

export class NamirasoftAccountHeader
{
    static cookie: NamirasoftAccountCookieHeader = new NamirasoftAccountCookieHeader();
    static req: NamirasoftAccountReqHeader = new NamirasoftAccountReqHeader();
    static res: NamirasoftAccountResHeader = new NamirasoftAccountResHeader();
}